import AppRouter from './application/router/AppRouter.tsx';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import EnvDebug from './components/EnvDebug.tsx';
import { LoadingBar } from './common/components/LoadingBar';

export default function App() {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        console.log('api', import.meta.env.VITE_API_V1_URL);
        if (searchParams.get('orgId')) {
            localStorage.setItem(
                'orgId',
                '"' + searchParams.get('orgId') + '"'
            );
        }
    }, []);

    return (
        <>
            <LoadingBar />
            <EnvDebug />
            <AppRouter />
        </>
    );
}
